import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';
import { ApplyBoundEnum } from '@Policy/utils/types';
import { getDefaultRiskAiFilter } from './cfg.exchange';
import { PolicyTypeEnum } from '@Policy/utils/constants';

const cfg = {
  policySubType: 0,
  policyType: 82,
  tmVirusscans: {
    vsApplyBound: 1,
    vsAdditionalThreatsActionType: 109,
    vsAllThreatsActionType: 2,
    vsRansomwareActionType: 109,
    vsMaliciousActionType: 109,
    vsMassingMailingActionType: 103,
    vsPackersActionType: 109,
    vsUncleanableThreatsActionType: 109,
    vsVirusesActionType: 109,
    vsWormsTrojansActionType: 10,
  },

  tmFileblockings: {
    fbApplyBound: 1,
  },

  tmWebthreatprotections: {
    wtpUrlcvEnabled: 1,
    wtpActionType: 109,
    wtpActionBlockedUrl: 109,
    wtpFileAction: 251,
    wtpTocApprovedUrlListEnabled: 0,
    wtpTocApprovedUrlListEntries: '',
    wtpExtractAttachmentUrl: 1,
    wtpApplyBound: ApplyBoundEnum.all,
  },

  tmDdafilters: {
    ddaActionHighRisk: 109,
    ddaActionMediumRisk: 109,
  },

  tmAntispamfilters: {
    asApplyBound: 1,
    asActionBec: 109,
    asActionOthers: 207,
    asActionPhish: 109,
    asActionRansome: 109,
    asActionMalicious: 109,
    asActionBlockedSender: 109,
    asActionScam: 109,
    wsNotifyRecipientActionType: 5,
  },
};

export function getExchangeInboundTemplateConfig(
  t: TFunction<'translation'>,
  featureShow: Record<string, boolean | number>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.EX.tmAntispamfilters.asDisclaimerSuspiciousSender',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleCompromisedUserSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleCompromisedUserMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleAdministratorMessage',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  const riskAi = getDefaultRiskAiFilter(
    t,
    PolicyTypeEnum.ExchangeInline,
    featureShow
  );
  merge(tempConfig, riskAi);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
